import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import * as React from "react";
import Box from "@mui/material/Box";
import { color } from "../../styles/color";

export const PropuestaMisMetasContainer = styled((props: any) => (
  <Grid
    container
    direction="column"
    rowSpacing={{ xs: 3, xl: 6 }}
    sx={{}}
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    {...props}
  />
))(({ theme }) => ({
  position: "relative",
  paddingLeft: 0,
  paddingRight: 0,
  [theme.breakpoints.down("mobile")]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
}));

export const PropuestaMisMetasGoalContainer = styled((props: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Grid item {...props} />
))(({ theme }) => ({
  fontSize: "16.32px",
  width: "100%",
  overflowX: "hidden",
  [theme.breakpoints.down("mobile")]: {
    overflowX: "scroll",
  },
}));

export const PropuestaMisMetasGoalContent = styled((props: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Grid item {...props} />
))(({ theme }) => ({
  width: "max-content",
  [theme.breakpoints.down("mobile")]: {
    paddingBottom: theme.spacing(3),
  },
}));

export const PropuestaMisMetasGoalInnerContainer = styled((props: any) => (
  <Grid
    container
    columnSpacing={{ xs: 6, xl: 6 }}
    rowSpacing={{ xs: 6, xl: 6 }}
    justifyContent="flex-start"
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    {...props}
  />
))(({ theme }) => ({
  // width of material spacing causes errors on safari so i set it to auto
  [theme.breakpoints.up("xs")]: {
    width: "auto",
  },
}));

export const PropuestaMisMetasFade = styled(
  (props: {
    background: string;
    transform?: string;
    position: "right" | "left";
  }) => (
    <Grid
      item
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...{
        ...props,
        background: undefined,
        transform: undefined,
        position: undefined,
      }}
    />
  )
)(({ theme, transform, background, position }) => ({
  [theme.breakpoints.up("xs")]: {
    height: 114,
    bottom: 52,
  },
  [theme.breakpoints.up("xl")]: {
    height: 133,
    bottom: 64,
  },
  width: 68,
  position: "absolute",
  background,
  transform,
  left: position === "left" ? 0 : undefined,
  right: position === "right" ? 0 : undefined,
}));

export const PropuestaContentHeader = styled((props: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Grid container direction="column" rowSpacing={{ xs: 8, xl: 8 }} {...props} />
))(({ theme }) => ({
  borderRadius: "24px 24px 0px 0px",
  background: color.gradient.headerHome,
  backdropFilter: "blur(80px)",
  [theme.breakpoints.up("xs")]: {
    paddingLeft: theme.spacing(18),
    paddingRight: theme.spacing(18),
    paddingBottom: theme.spacing(12),
  },
  [theme.breakpoints.up("xl")]: {
    paddingLeft: theme.spacing(18),
    paddingRight: theme.spacing(18),
    paddingBottom: theme.spacing(15),
  },
  [theme.breakpoints.down("mobile")]: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(15),
  },
}));

export const PropuestaContentContainer = styled(
  (props: { downmobile: boolean; children: React.ReactNode }) => (
    <Grid
      container
      direction="column"
      rowSpacing={{ xs: props.downmobile ? 12 : 16, xl: 16 }}
      justifyContent="center"
      alignItems="center"
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...{ ...props, downmobile: undefined }}
    />
  )
)(({ theme }) => ({
  background: color.greyscale.white[100],
  borderRadius: "0px 0px 24px 24px",
  [theme.breakpoints.up("xs")]: {
    paddingLeft: theme.spacing(25),
    paddingRight: theme.spacing(25),
    paddingBottom: theme.spacing(20),
    paddingTop: theme.spacing(16),
  },
  [theme.breakpoints.up("xl")]: {
    paddingLeft: theme.spacing(44),
    paddingRight: theme.spacing(44),
    paddingBottom: theme.spacing(20),
    paddingTop: theme.spacing(16),
  },
  [theme.breakpoints.down("mobile")]: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    paddingTop: theme.spacing(8),
  },
}));

export const StyledObjectivesContainerBox = styled((props: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box {...props} />
))(({ theme }) => ({
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  [theme.breakpoints.up("xs")]: {
    marginTop: theme.spacing(10),
    maxWidth: theme.spacing(296),
  },
  [theme.breakpoints.up("xl")]: {
    marginTop: theme.spacing(10),
    maxWidth: theme.spacing(360),
  },
}));

export const StyledContentContainerBox = styled((props: any) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box {...props} />
))(({ theme, marginTop, marginBottom, background }) => ({
  width: "100%",
  marginLeft: "auto",
  marginRight: "auto",
  background: background ?? color.greyscale.white[100],
  borderRadius: "24px",
  [theme.breakpoints.up("xs")]: {
    marginBottom: marginBottom ?? theme.spacing(56),
    marginTop: marginTop ?? theme.spacing(18),
    maxWidth: theme.spacing(296),
  },
  [theme.breakpoints.up("xl")]: {
    marginBottom: marginBottom ?? theme.spacing(56),
    marginTop: marginTop ?? theme.spacing(24),
    maxWidth: theme.spacing(360),
  },
  [theme.breakpoints.down("mobile")]: {
    marginBottom: marginBottom ?? theme.spacing(0),
    marginTop: marginTop ?? theme.spacing(20),
    maxWidth: theme.spacing(360),
    borderRadius: "24px 24px 0px 0px",
  },
}));
